import { differenceInCalendarDays } from 'date-fns'

import { type GetTargetProps, type Target } from './DatePicker.types'

export const getTarget = ({ day, startDate, mode, currentTarget }: GetTargetProps): Target => {
  if (!startDate || mode === 'OUTWARD' || mode === 'SINGLE_START_DATE') {
    return 'START'
  }

  if (mode === 'INWARD' || mode === 'SINGLE_END_DATE') {
    return 'END'
  }

  if (mode === 'ROUND_TRIP') {
    return differenceInCalendarDays(day, startDate) < 0 || currentTarget === 'INIT' || currentTarget === 'END'
      ? 'START'
      : 'END'
  }

  return 'START'
}
